import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';

/**
 * Styled components for the SearchSummary component
 */

export const Container = styled.div`
  padding-top: ${fromTheme('spacing_large')};
  padding-right: ${fromTheme('spacing_large')};
  padding-bottom: ${fromTheme('spacing_large')};
  font-size: ${fromTheme('font_size')};
  color: ${fromTheme('color_text')};
`;
